import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KeyResource {
  private readonly apiUrl: string;
  constructor(private http: HttpClient, @Inject(environmentToken) environment: Environment) {
    this.apiUrl = environment.apiUrl + environment.apiPath + '/keys';
  }

  isBuildingSecure(buildingId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/building/${buildingId}/is-secure`);
  }
}
